export default {
  track(url) {
    const medscape    = 'medscape.com',
         internalLink = url.indexOf(medscape);
     let identifierLink = '',
        eventLnk = '';
    if (internalLink > -1) {
        identifierLink = 'INTLINK_';
        eventLnk = 'vidvbp-intlink';
    } else {
        identifierLink = 'EXTLINK_';
        eventLnk = 'vidvbp-extlink';
    }
    return function() {
    };
  }
};



// WEBPACK FOOTER //
// ./modules/mixins/url_tracking.js